const axiosConfig = {
    baseURL: process.env.REACT_APP_BE_HTTP_URL
};

export default axiosConfig;
